import { FixedTermMarketsDiscover } from '@/components/discoverOpportunities/fixedTermMarketsDiscover'
import { Page } from '@/components/layout/wrappers'
import { queryClient } from '@/config/query/queryClient'
import { fixedTermMarketsQueryOptions } from '@/queries/fixedTermMarkets.query'
import { getMetaTags } from '@/utils/meta/getMetaTags'
import type { MetaFunction } from 'react-router'
import { useLoaderData } from 'react-router'

export const loader = async () => {
  const initialFixedTermMarketsData = await queryClient.ensureQueryData(fixedTermMarketsQueryOptions())

  return { initialFixedTermMarketsData }
}

export const shouldRevalidate = ({
  currentUrl,
  nextUrl,
  defaultShouldRevalidate,
}: {
  currentUrl: URL
  nextUrl: URL
  defaultShouldRevalidate: boolean
}) => {
  if (currentUrl.pathname === nextUrl.pathname) {
    return false
  }

  return defaultShouldRevalidate
}

export const meta: MetaFunction = ({ location }) => {
  return getMetaTags({
    title: 'Fixed-term markets',
    description: 'Discover fixed-term DeFi opportunities on vaults.fyi.',
    url: location.pathname,
  })
}

export default function FixedTerm() {
  const { initialFixedTermMarketsData } = useLoaderData<typeof loader>()

  return (
    <Page>
      <FixedTermMarketsDiscover initialData={initialFixedTermMarketsData} />
    </Page>
  )
}
